import {
  Box,
  Stack,
  Text,
  Heading,
  Columns,
  Column,
  Bleed,
  Page,
  PageBlock,
} from 'braid-design-system';
import { Helmet } from 'react-helmet';

import { FaqAccordion } from 'src/components/FaqAccordion/FaqAccordion';
import { SiteWideFooter } from 'src/components/SiteWideFooter';

import { ExitStrategy } from './components/ExitStrategy';
import { Testimonial } from './components/Testimonial';
import { WhySeekBusiness } from './components/WhySeekBusiness';

import * as styles from './PrivateSellerSEM.css';

const slideTexts = [
  'Restaurant',
  'Beauty Spa',
  'Gym Studio',
  'Online Store',
  'Post Office',
  'Pub & Café',
  'Bottle Shop',
  'Supermarket',
  'Hair Salon',
  'Laundromat',
  'Restaurant',
];

const faqs = [
  {
    question: 'What happens when I register with SEEK Business?',
    answer:
      "When you register with SEEK Business you will get access to our exclusive resources. Then when you're ready, choose an ad pack, create and publish your ad and once it's live, we'll match you with buyers who will contact you directly.",
  },
  {
    question: 'When should I prepare my exit strategy?',
    answer:
      "An exit plan can help guide the decisions you make in your business today, so you don't lose value in your business sale in the future. So at a minimum, start planning your exit at least 12 months before you plan to sell.",
  },
  {
    question: 'How do I determine the value of my business?',
    answer:
      'Sign up with SEEK Business to access our value calculator guide to get an idea of where to start.',
  },
  {
    question: 'Who should advertise on SEEK Business?',
    answer:
      'Anybody who owns a business and would like to sell it privately by liaising directly with buyers.',
  },
  {
    question: 'How long will it take me to sell my business?',
    answer:
      'On average it takes 6-9 months to sell, sometimes more especially if your business is valued at $1M or more.',
  },
  {
    question: 'Do you charge commission?',
    answer:
      'No, we do not charge commission and there are no hidden fees. We charge a flat rate to advertise.',
  },
  {
    question: 'Will my ad be placed on other websites?',
    answer:
      'No, when you advertise with SEEK Business your ad is only displayed on our website.',
  },
];

const PrivateSellerSEM = () => (
  <Page footer={<SiteWideFooter />}>
    <Helmet>
      <title>SEEK Business - Sell Your Business</title>
      <meta name="robots" content="noindex" />
      <meta name="robots" content="nofollow" />
    </Helmet>

    <Stack space="xxxlarge">
      <Box
        id="jumbotron-white-background"
        padding={{
          mobile: 'xlarge',
          tablet: 'xxlarge',
        }}
        background="brandAccent"
      >
        <PageBlock>
          <Box id="jumbotron-content" className={styles.title.main}>
            <Stack space="xlarge" align="left">
              {/* Intro Text */}
              <Bleed horizontal="xlarge">
                <Box className={styles.title.mainContainer}>
                  <Heading level="1">
                    <Columns space="xxsmall">
                      <Column>
                        <div className={styles.title.column.left}>
                          Sell&nbsp;your&nbsp;
                        </div>
                      </Column>
                      <Column>
                        <div className={styles.title.column.right}>
                          <ul className={styles.slide.container}>
                            {slideTexts.map((text, index) => (
                              <li
                                className={styles.slide.text}
                                key={`slide-${index}`}
                              >
                                {text}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </Column>
                    </Columns>
                  </Heading>
                </Box>
              </Bleed>
              <Text>
                Whether you’re ready to sell now or in the future, SEEK Business
                has everything you need to sell your business with confidence.
              </Text>
            </Stack>
          </Box>
        </PageBlock>
      </Box>
      <PageBlock width="medium">
        <Stack space="xxxlarge">
          <ExitStrategy />
          <FaqAccordion faqs={faqs} />
          <Testimonial />
          <WhySeekBusiness />
        </Stack>
      </PageBlock>
    </Stack>
  </Page>
);

export default PrivateSellerSEM;
